<template>
  <div @click="openDropdown = false">
    <div class="space-y-4">
      <div class="flex justify-between">
        <h2 class="font-semibold uppercase text-gray-600">Employees</h2>
        <div class="flex">
          <router-link
            to="/corporate/employees/add"
            class="px-4 py-2 bg-blue-500 text-white font-semibold rounded hover:bg-blue-700"
          >
            Add Employee
          </router-link>
        </div>
      </div>

      <div class="flex justify-between">
        <div class="relative max-w-sm w-full">
          <div class="absolute inset-y-0 flex items-center px-3">
            <i class="material-icons text-gray-500">search</i>
          </div>
          <input
            v-model="searchKey"
            @keyup="getEmployees"
            class="rounded border pl-10 pr-4 py-2 w-full"
            placeholder="Search"
          />
        </div>
        <div class="w-64">
          <select class="form-select w-full" @change="setActiveFilter">
            <option :selected="selectedActiveFilter === 'both'" value="both"
              >All Status</option
            >
            <option :selected="selectedActiveFilter === 'active'" value="active"
              >Active</option
            >
            <option
              :selected="selectedActiveFilter === 'inactive'"
              value="inactive"
              >Inavtive</option
            >
          </select>
        </div>
      </div>

      <div class="inline-block min-w-full shadow rounded-lg mt-4">
        <table class="min-w-full leading-normal">
          <thead>
            <tr>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                id
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                elmployee name
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                phone number
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Active
              </th>
              <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"></th>
            </tr>
          </thead>
          <tbody class="relative" v-if="employees.length">
            <tr v-for="(employee, index) in employees" :key="employee._id">
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{ employee._id }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{ employee.name }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{ employee.phone }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{ employee.active }}
                </p>
              </td><td
                class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-right"
              >
                <div @click.stop class="relative inline-block text-left">
                  <div>
                    <span class="rounded-md shadow-sm">
                      <button
                        @click="toggleDropdown(index)"
                        type="button"
                        class="inline-flex justify-center w-full rounded-md px-4 py-2 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
                        aria-haspopup="true"
                        :aria-expanded="openDropdown === index"
                      >
                        <i class="material-icons">more_vert</i>
                      </button>
                    </span>
                  </div>
                  <transition
                    enter-active-class="transition ease-out duration-100"
                    enter-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95"
                  >
                    <div
                      v-if="openDropdown === index"
                      class="origin-top-right absolute right-0 w-56 rounded-md shadow-lg z-10"
                    >
                      <div
                        class="rounded-md bg-white shadow-xs"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="options-menu"
                      >
                        <!-- <div class="py-1">
                          <router-link
                            :to="`rides?driver=${employee._id}`"
                            class="flex items-center space-x-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                          >
                            <i class="material-icons">history</i>
                            <span>Ride History</span>
                          </router-link>
                        </div>
                        <div class="border-t border-gray-100"></div> -->
                        <div class="py-1">
                          <!-- <router-link
                            :to="`drivers/${employee._id}/edit`"
                            class="flex items-center space-x-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                          >
                            <i class="material-icons">edit</i>
                            <span>Edit</span>
                          </router-link> -->
                          <button
                            @click="toggleActive(employee._id, employee.active)"
                            type="button"
                            class="w-full flex items-center space-x-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                          >
                            <i v-if="employee.active" class="material-icons">
                              close
                            </i>
                            <i v-else class="material-icons">check</i>
                            <span>{{
                              employee.active ? "Make Inactive" : "Make Active"
                            }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
              </td>
            </tr>
            <div
              v-if="loading"
              class="absolute inset-0 h-full w-full flex items-center justify-center bg-black bg-opacity-25"
            >
              <i class="material-icons text-6xl spin">sync</i>
              <span class="block invisible">Loading...</span>
            </div>
          </tbody>
          <tbody v-else>
            <tr>
              <td
                colspan="7"
                class="bg-white py-4 text-center text-gray-600 font-semibold"
              >
                <div v-if="loading" class="inline-block">
                  <i class="material-icons text-6xl spin">sync</i>
                  <span class="block invisible">Loading...</span>
                </div>
                <div v-else class="inline-block">
                  <i class="material-icons text-6xl">warning</i>
                  <span class="block">No Employees!</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex justify-between items-end">
        <p class="text-gray-600">
          Showing
          <strong>{{ start }}</strong> to <strong>{{ end }}</strong> of
          <strong>{{ paginator.count }}</strong> entries
        </p>
        <div class="flex items-center space-x-4">
          <div>
            Per page:
            <select
              class="form-select"
              name="perPage"
              id="perPage"
              @change="setPerPage"
            >
              <option :selected="perPage === '10'" value="10">10</option>
              <option :selected="perPage === '25'" value="25">25</option>
              <option :selected="perPage === '50'" value="50">50</option>
              <option :selected="perPage === '100'" value="100">100</option>
            </select>
          </div>
          <div class="space-x-2 flex">
            <button
              @click="goToPrev"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_left</i>
            </button>
            <button
              v-for="page in total"
              :key="`pageLink-${page}`"
              type="button"
              class="p-2"
              :class="{
                'text-gray-500 hover:text-gray-800': currentPage !== page,
                'text-gray-900': currentPage === page
              }"
              :disabled="currentPage === page"
              @click="goToPage(page)"
            >
              {{ page }}
            </button>
            <button
              @click="goToNext"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_right</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/mixins/Pagination";

export default {
  mixins: [Pagination],
  data() {
    return {
      employees: [],
      openDropdown: false,
      loading: true,
      searchKey: "",
      confirmOpen: false,
      deleting: false,
      selectedActiveFilter: "both"
    };
  },
  created() {
    this.getEmployees();
  },
  mounted() {
    document.body.addEventListener("keyup", this.escapeListener);
  },
  beforeDestroy() {
    document.body.removeEventListener("keyup", this.escapeListener);
  },
  watch: {
    selectedActiveFilter() {
      this.getEmployees();
    },
    currentPage() {
      this.getEmployees();
    },
    perPage() {
      this.currentPage === 1 ? this.getEmployees() : (this.currentPage = 1);
    }
  },
  computed: {
    corporateId() {
      return this.$store.state.auth.account.corporate._id;
    }
  },
  methods: {
    setActiveFilter(e) {
      this.selectedActiveFilter = e.target.value;
    },
    escapeListener(e) {
      if (e.keyCode === 27) {
        this.closeConfirmBox();
      }
    },
    getEmployees() {
      let active;

      if (this.selectedActiveFilter === "active") {
        active = true;
      } else if (this.selectedActiveFilter === "inactive") {
        active = false;
      } else {
        active = null;
      }

      this.loading = true;
      this.$http
        .get(
          `corporates/${this.corporateId}/employees?page=${this.currentPage}${
            this.searchKey ? "&q=" + this.searchKey : ""
          }&limit=${this.perPage}&${active !== null ? "active=" + active : ""}`
        )
        .then(response => {
          this.employees = response.data.data;
          this.paginator = {
            nextPage: response.data.nextPage,
            prevPage: response.data.prevPage,
            count: response.data.count
          };
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    toggleActive(id, active) {
      this.loading = true;
          this.openDropdown = false;
      this.$http
        .patch(`employees/${id}`, {active: !active}
        )
        .then(() => {
        })
        .catch(err => console.log(err))
        .finally(() => (this.getEmployees()));
    },
    toggleDropdown(index) {
      if (this.openDropdown === index) {
        this.openDropdown = false;
      } else {
        this.openDropdown = index;
      }
    }
  }
};
</script>
